/* <rr-slider-dots> — marcas del carrusel de fotos del PDP en una columna (móvil
   y tableta; 19 oct 2026: «un slider para ver las diferentes fotos de
   cada variante… un diseño más clásico»). El carrusel es CSS (scroll-snap en la
   galería visible, main-product); aquí solo se pintan las marcas, se marca la
   foto que se ve y al tocar una marca se va a su foto. Al cambiar de piedra
   (rr:variant) rr-gallery enseña otro grupo: las marcas se rehacen y el
   carrusel vuelve a su primera foto. En el ordenador no hace nada. */
(() => {
  if (customElements.get('rr-slider-dots')) return;
  const unaColumna = window.matchMedia('(max-width: 1023px)');

  class RRSliderDots extends HTMLElement {
    connectedCallback() {
      this.layout = this.closest('.rr-pdp__layout') || document;
      // después de que rr-gallery cambie el grupo visible (oye el mismo evento)
      this.onCambio = () => setTimeout(() => this.montar(), 0);
      document.addEventListener('rr:variant', this.onCambio);
      unaColumna.addEventListener('change', this.onCambio);
      this.montar();
    }

    disconnectedCallback() {
      document.removeEventListener('rr:variant', this.onCambio);
      unaColumna.removeEventListener('change', this.onCambio);
      this.soltar();
    }

    soltar() {
      if (this.galeria && this.onScroll) this.galeria.removeEventListener('scroll', this.onScroll);
      this.galeria = null;
    }

    montar() {
      const galeria = [...this.layout.querySelectorAll('.rr-pdp__gallery')].find((g) => !g.hidden);
      if (galeria === this.galeria) return;
      this.soltar();
      this.replaceChildren();
      if (!galeria || !unaColumna.matches) return;
      const fotos = [...galeria.children].filter((t) => t.classList.contains('rr-pdp__tile'));
      if (fotos.length < 2) return;
      this.galeria = galeria;
      this.actual = -1;
      galeria.scrollLeft = 0;
      const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.fotos = fotos;
      this.marcas = fotos.map((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rr-pdp__dot';
        b.setAttribute('aria-label', `${i + 1} / ${fotos.length}`);
        b.addEventListener('click', () => {
          this.via = 'dot';
          galeria.scrollTo({ left: i * galeria.clientWidth, behavior: quieto ? 'auto' : 'smooth' });
        });
        this.append(b);
        return b;
      });
      // sin requestAnimationFrame: con la página en segundo plano no corre y la marca se quedaba quieta
      this.onScroll = () => this.marcar(Math.round(galeria.scrollLeft / Math.max(1, galeria.clientWidth)));
      galeria.addEventListener('scroll', this.onScroll, { passive: true });
      this.marcar(0);
    }

    marcar(i) {
      if (i === this.actual) return;
      const montando = this.actual < 0;
      this.actual = i;
      this.marcas?.forEach((b, j) => b.setAttribute('aria-current', j === i ? 'true' : 'false'));
      if (montando) return;
      // Medición (rr_gallery): la foto donde se para el carrusel, no cada una por la que pasa
      clearTimeout(this.rrT);
      this.rrT = setTimeout(() => {
        const t = this.fotos && this.fotos[i];
        const video = t && (t.matches('rr-video') || t.querySelector('video'));
        if (window.rrTrack) window.rrTrack('rr_gallery', { action: this.via || 'swipe', media_index: i, media_type: video ? 'video' : 'image' });
        this.via = '';
      }, 400);
    }
  }

  customElements.define('rr-slider-dots', RRSliderDots);
})();
